// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3PU-j","file":"styles_file__2PG2d"};